import { Text } from "@clipboard-health/ui-react";
import { isDefined } from "@clipboard-health/util-ts";
import { Alert, AlertTitle } from "@mui/material";
import { BulletedTextList } from "@src/appV2/AttendanceScore/components/BulletedTextList";
import { parseISO } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export interface RestrictedAccountStatusWarningProps {
  reEnrollmentDate?: string;
  extraInformation?: string[];
  timezone: string;
}

export function RestrictedAccountStatusWarning(props: RestrictedAccountStatusWarningProps) {
  const { reEnrollmentDate, extraInformation, timezone } = props;

  return (
    <Alert variant="outlined" severity="error" icon={false}>
      <AlertTitle>
        <Text bold color={(theme) => theme.palette.error.main}>
          Your account is Restricted{" "}
          {isDefined(reEnrollmentDate)
            ? `until ${formatInTimeZone(
                parseISO(reEnrollmentDate),
                timezone,
                "h:mm aa MM/dd/yyyy"
              )}`
            : ""}
        </Text>
      </AlertTitle>
      {isDefined(extraInformation) && extraInformation.length > 0 && (
        <BulletedTextList items={extraInformation} />
      )}
    </Alert>
  );
}
